import { sessionShape } from "../../shapes";

import TicketSearch from "./TicketSearch";
import { Container, Row, Column } from "../Grid";
import { withSession } from "../../context";
import NotFound from "../Errors/NotFound";

type Props = {
  session?: sessionShape;
};

export function Tickets({ session }: Props) {
  // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
  if (session.subscriptionType !== "paid") {
    return <NotFound />;
  }
  return (
    <Container>
      <Row>
        <Column>
          <TicketSearch />
        </Column>
      </Row>
    </Container>
  );
}
export default withSession(Tickets);
